import React, { Component } from 'react';
import { popup } from '~/decorators';
import PropTypes from 'prop-types';
import Score from './Score';
import Judge from './Judge';

export default
@popup
class LeaderboardScoreRuns extends Component {
    static propTypes = {
        scoreStyle: PropTypes.object.isRequired,
        athlete: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        runs: PropTypes.object.isRequired,
        roundConfig: PropTypes.object.isRequired,
        showJudgeScoresPopup: PropTypes.bool.isRequired
    }

    onResized = () => {
        const {
            showJudgeScoresPopup,
            popupVisible,
            popupHide
        } = this.props;

        if (!showJudgeScoresPopup && popupVisible) {
            popupHide();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResized, false);
        window.addEventListener('orientationchange', this.onResized, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResized);
        window.removeEventListener('orientationchange', this.onResized);
    }

    render() {
        const {
            scoreStyle,
            athlete,
            colors,
            roundConfig,
            runs,
            popupShow,
            showJudgeScoresPopup
        } = this.props;

        if (!runs.values) {
            return null;
        }

        const { mostRunsCount } = roundConfig;

        const values = [
            ...(runs.values || [])
        ];

        if (mostRunsCount < values.length) {
            values.splice(
                mostRunsCount,
                values.length - mostRunsCount
            );
        }

        while (values.length < mostRunsCount) {
            values.push({ dummy: true });
        }

        return (
            <div className="score runs">
                {values
                .filter(({ rank, dummy }) => !!rank || dummy)
                .map((
                    {
                        rank,
                        highlight,
                        drop,
                        judges
                    },
                    i
                ) => {
                    let style = highlight
                        ? colors.highlight
                        : colors.nonCounting;

                    if (athlete.isLive) {
                        style = highlight
                            ? colors.highlightActive
                            : colors.nonCounting;
                    }

                    if (drop) {
                        style = colors.drop;
                    }

                    const id = `leaderboard_run_${athlete.externalId}_${i}`;

                    return (
                        <Score
                            key={id}
                            style={{
                                ...style,
                                ...scoreStyle
                            }}
                            onTouchStart={ev => ev.stopPropagation()}
                            onMouseDown={ev => ev.stopPropagation()}
                            onClick={(ev) => {
                                if (!showJudgeScoresPopup) {
                                    return;
                                }

                                popupShow(id, ev.target, (
                                    <Judge
                                        groupKey={id}
                                        judges={judges}
                                        scoreStyle={scoreStyle}
                                        athlete={athlete}
                                        colors={colors}
                                        roundConfig={roundConfig}
                                    />
                                ));
                            }}
                        >
                            {rank}
                        </Score>
                    );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/Runs.js